import React from 'react';
import { testimonios } from '../data/testimonios';
export function Testimonios() {
  return <section aria-labelledby="testimonios-titulo" className="w-full bg-canvas px-6 py-20" data-id="element-208" data-mp="3a0xt0iim4v2c">
      <div className="mx-auto max-w-content" data-id="element-209" data-mp="35zlzi1wmbpov">
        <div className="text-center" data-id="element-210" data-mp="35yaw43734jya">
          <h2 id="testimonios-titulo" className="font-display text-3xl font-bold text-ink sm:text-4xl" data-id="element-211" data-mp="310rgozyni14r">
            Lo que dicen manicuristas de toda LATAM
          </h2>
          <p className="mt-4 text-sm text-muted" data-id="element-212" data-mp="2w2zftgg134of">
            ⭐⭐⭐⭐⭐ 4.9/5 · Más de 2.500 profesionales en 7 países
          </p>
        </div>

        <ul className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-213" data-mp="2mbd6xqr5xhou">
          {testimonios.map(t => <li key={t.nombre} className="flex h-full flex-col rounded-3xl border border-edge bg-surface p-7" data-id="element-214" data-mp="2ib2qfk5qv8vq">
              <blockquote className="font-display text-base leading-relaxed text-ink" data-id="element-215" data-mp="2da5a7d4aoowv">“{t.texto}”</blockquote>

              <div className="mt-auto flex items-center gap-3 pt-6" data-id="element-216" data-mp="28dexmzrp8bg7">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-soft text-xs font-bold text-brand-700" data-id="element-217" data-mp="1nc1bpzi724sn">
                  {t.iniciales}
                </span>
                <div data-id="element-218" data-mp="1ecefds4bnp6g">
                  <p className="text-sm font-bold text-ink" data-id="element-219" data-mp="1ed620dfxyckl">{t.nombre}</p>
                  <p className="text-xs text-muted" data-id="element-220" data-mp="1jag16kt4u2lm">{t.ciudad}</p>
                  <p className="text-xs text-muted" data-id="element-221" data-mp="1j8lcqwinjscs">{t.rol}</p>
                </div>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}